module.exports = __webpack_public_path__ + "img/EUlogo.0a8954a3.jpg";